import type { ToastContainerOptions } from "vue3-toastify"

/**
 * The app's toast options, in one place. `main.ts` installs them and the theme
 * store passes them again with the theme, because `updateGlobalOptions`
 * replaces the options instead of merging them: called with the theme alone it
 * reset every toast to the library default (top-right, which on a phone sits at
 * `top: 0` under the status bar, COACHIO-1549).
 */
export const toastOptions: ToastContainerOptions = {
    // Was 500ms: gone before you could read it, which made every toast a flash
    // rather than a message.
    autoClose: 2600,
    // `src/theme/toast.css` moves this container below the status bar.
    position: "top-center",
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    theme: "light",
    transition: "slide",
    dangerouslyHTMLString: false,
}
